"use client"
import { useState } from 'react'
import { Copy, X } from 'lucide-react'

export default function CouponBannerClient({ code, note }: { code: string; note?: string }) {
  const [visible, setVisible] = useState(true)
  const [copied, setCopied] = useState(false)
  if (!visible) return null
  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 text-amber-900 px-4 py-2 text-sm flex items-center justify-between rounded">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-medium uppercase tracking-wide text-xs text-amber-800">Limited offer</span>
        <span className="font-mono bg-white/80 rounded px-2 py-0.5 text-sm">{code}</span>
        {note && <span className="opacity-80">— {note}</span>}
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={async () => { try { await navigator.clipboard.writeText(code); setCopied(true); setTimeout(()=>setCopied(false), 1500) } catch (_) {} }}
          aria-label={copied ? 'Copied!' : 'Copy'}
          className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs border border-amber-300 hover:bg-white/60 whitespace-nowrap"
        >
          <Copy size={14} className="hidden sm:inline" />
          <span className="sm:hidden">{copied ? 'Copied!' : 'Copy'}</span>
          <span className="hidden sm:inline">{copied ? 'Copied!' : 'Copy code'}</span>
        </button>
        <button onClick={()=>setVisible(false)} aria-label="Close" className="inline-flex items-center justify-center rounded p-1 text-amber-900/70 hover:bg-amber-100 hover:text-amber-900">
          <X size={16} />
        </button>
      </div>
    </div>
  )
}
